<script>
	export default {
		name: 'ForbiddenPage',
	}
</script>
<style scoped>
.forbidden-page {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	background-color: #f2f2f2;
	color: #333;
	text-align: center;
	font-family: Arial, sans-serif;
}

.content h1 {
	font-size: 100px;
	margin: 0;
	font-weight: bold;
}

.content p {
	font-size: 20px;
}
</style>
<template>
	<div class="forbidden-page">
		<div class="content">
			<h1>403</h1>
			<p>Forbidden</p>
			<p>You don't have permission to access this page.</p>
			<a href="javascript:" class="go-back-btn" @click="$router.go(-2)">Go Back</a>
		</div>
	</div>
</template>